export default __webpack_public_path__ + "static/media/Calendar.4d9c6251.svg";